<router-outlet></router-outlet>

@if (showBootSkeleton()) {
  <div class="unit-route-loading-overlay" aria-hidden="false">
    <app-unit-route-loading-skeleton />
  </div>
}
